import qs from "qs";
import { searchRequestData } from "../../Utility/apiHelper";
import { requestHideLoader, requestShowLoader } from "../Global/action";
import * as actionType from './type';

const ARRAY_SERIALIZER = params => qs.stringify(params, { arrayFormat: "repeat" });

export const requestGetAllWorkflows = (searchState) => async (dispatch) => {
    dispatch(requestShowLoader())
    try {
        const workflowSearchUrl = `${process.env.REACT_APP_BASE_URL}api/workflows/search`;

        // Build params object — strip empty/null/undefined values so the URL stays clean
        const params = {};
        Object.entries(searchState || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params[key] = value;
            }
        });

        // Pass as { params, paramsSerializer } — same shape that useSearchExecutor uses for Tasks.
        // searchRequestData spreads the second argument into Axios config, so params ends up under
        // config.params which Axios serialises into query-string properly.
        const responsedata = await searchRequestData(
            { params, paramsSerializer: ARRAY_SERIALIZER },
            workflowSearchUrl,
            false
        );

        dispatch({
            type: actionType.RECEIVED_ALL_WORKFLOWS,
            payload: responsedata?.data
        })
    } catch (error) {
    }
    dispatch(requestHideLoader())
}

/**
 * Fetches summary log rows for a specific workflow definition (no executionJson).
 */
export const requestGetWorkflowLogs = (workflowDefinitionId) => async (dispatch) => {
    dispatch(requestShowLoader())
    try {
        const url = `${process.env.REACT_APP_BASE_URL}api/workflows/logs`;
        const responsedata = await searchRequestData(
            { params: { workflowDefinitionId } },
            url,
            false
        );
        dispatch({
            type: actionType.RECEIVED_WORKFLOW_LOGS,
            payload: responsedata?.data || []
        })
    } catch (error) {
        dispatch({ type: actionType.RECEIVED_WORKFLOW_LOGS, payload: [] })
    }
    dispatch(requestHideLoader())
}

/**
 * Fetches the full log row including executionJson for the detail dialog.
 */
export const requestGetWorkflowLogDetail = (logId) => async (dispatch) => {
    dispatch(requestShowLoader())
    try {
        const url = `${process.env.REACT_APP_BASE_URL}api/workflows/logs/${logId}`;
        const responsedata = await searchRequestData({}, url, false);
        dispatch({
            type: actionType.RECEIVED_WORKFLOW_LOG_DETAIL,
            payload: responsedata?.data || null
        })
    } catch (error) {
        dispatch({ type: actionType.RECEIVED_WORKFLOW_LOG_DETAIL, payload: null })
    }
    dispatch(requestHideLoader())
}
